module.exports = __webpack_public_path__ + "media/images/display/blur-contents-553c5ecd9cf52af98832c9784adbc670.png";